import { useMutation } from "@tanstack/react-query";
import { getRCSReportByCustomers } from "../api/RCSReportByCustomers";
import { useAuth } from "../../../../../Context/AuthContext";
export const useGetRCSReportByCustomers = () => {
  const auth = useAuth();
  const user = auth.getSessionData();

  return useMutation({
    mutationKey: ["getRCSReportByCustomers"],
    mutationFn: async (data) =>
      await getRCSReportByCustomers({
        token: user.token,
        data: {
          ...data
        },
      }),
  });
};
